import React, { FunctionComponent } from 'react';

import Form from './Form';

const Cards: FunctionComponent<{
  paymentInfo: any;
  updateInternetCharges: Function;
  type: string;
  amount: number;
  internetCharges: number;
  fromFastag: any;
}> = ({ paymentInfo, updateInternetCharges, type, amount, internetCharges, fromFastag }) => {
  return (
    <div>
      <Form
        paymentInfo={paymentInfo}
        updateInternetCharges={updateInternetCharges}
        type={type}
        amount={amount}
        internetCharges={internetCharges}
        fromFastag={fromFastag}
      />
    </div>
  );
};

export default Cards;
